import { Text, Heading, Card, Stack, Inline } from '@etg/wings';
import { css, mediaQueries } from '@eti/styles';
import { ArrowLeft, ArrowRight } from '@phosphor-icons/react';
import { useDirection } from '@eti/providers';
import { CABIN_UPGRADE } from '../../products';
import CabinUpgradeAvailabilityStatus from './CabinUpgradeAvailabilityStatus';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const availabiltyCardStyles = css`
  border: solid #e5e5e5 1px;
`;
const availabiltyListStyles = css`
  padding: 16px 8px 0;

  li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 0 !important; /* stylelint-disable-line declaration-no-important */
    padding: 8px;

    @media ${mediaQueries.small.only} {
      align-items: flex-start;
      flex-direction: column;
    }
  }
`;
const availabilityStatusStyles = css`
  align-items: center;
  display: flex;
  flex-direction: row;

  @media ${mediaQueries.small.only} {
    margin-top: 8px;
  }
`;
const CabinUpgradeAvailabilityCard = _ref => {
  let {
    availabilityList,
    availabilityTexts
  } = _ref;
  const {
    isRTL
  } = useDirection();
  const {
    availabilityCard,
    destinationLabel
  } = availabilityTexts;
  return /*#__PURE__*/_jsxs(Card, {
    className: availabiltyCardStyles,
    "data-testid": `${CABIN_UPGRADE.name}-availability-card`,
    children: [/*#__PURE__*/_jsx(Heading, {
      as: "h5",
      level: 4,
      children: availabilityCard.availabilityTitle
    }), /*#__PURE__*/_jsx("ul", {
      className: availabiltyListStyles,
      children: availabilityList.map((availabilty, index) => {
        const {
          isAvailable = false,
          origin = {},
          destination = {},
          segmentIndex = 0
        } = availabilty;
        const {
          cityName: originAirportName,
          name: originAirportFullName,
          code: originAirportCode
        } = origin;
        const {
          cityName: destinationAirportName,
          name: destinationAirportFullName,
          code: destinationAirportCode
        } = destination;
        const availabilityStatusText = isAvailable ? availabilityCard.availableStatus : availabilityCard.unavailableStatus;
        const ariaLabelText = `${originAirportFullName} ${destinationLabel} ${destinationAirportFullName} ${availabilityStatusText}`;
        return /*#__PURE__*/_jsxs("li", {
          "aria-label": ariaLabelText,
          children: [/*#__PURE__*/_jsxs(Inline, {
            spacing: 4,
            children: [/*#__PURE__*/_jsxs(Text, {
              "aria-hidden": true,
              "data-testid": `${CABIN_UPGRADE.name}-availability-card-segment-${segmentIndex}-origin-text`,
              children: [originAirportName, " ", originAirportCode]
            }), isRTL ? /*#__PURE__*/_jsx(ArrowLeft, {
              "aria-hidden": true,
              size: 20,
              weight: "light"
            }) : /*#__PURE__*/_jsx(ArrowRight, {
              "aria-hidden": true,
              size: 20,
              weight: "light"
            }), /*#__PURE__*/_jsxs(Text, {
              "aria-hidden": true,
              "data-testid": `${CABIN_UPGRADE.name}-availability-card-segment-${segmentIndex}-destination-text`,
              children: [destinationAirportName, " ", destinationAirportCode]
            })]
          }), /*#__PURE__*/_jsx(Stack, {
            className: availabilityStatusStyles,
            "data-testid": `${CABIN_UPGRADE.name}-availability-card-segment-${segmentIndex}-availability-status`,
            spacing: 4,
            children: /*#__PURE__*/_jsx(CabinUpgradeAvailabilityStatus, {
              availabilityTexts: availabilityTexts,
              isSegmentAvailable: isAvailable
            })
          })]
        }, index);
      })
    })]
  });
};
export default CabinUpgradeAvailabilityCard;
//# sourceMappingURL=CabinUpgradeAvailabilityCard.js.map